import styled from 'styled-components'
import { breakpoints } from '../../../../constants/breakpoits.constants'
import { container } from '../../../../styles/reusable.style'
import ellipse from '../../../../../assets/images/ellipse.svg'
import { DARKORANGE } from '../../../../styles/colors.style'

export const StyledStoryContainer = styled.section`
	${container} position: relative;
	border-top: solid 2px ${DARKORANGE};

	@media (min-width: ${breakpoints.MOBILE}px) {
		padding-top: 8rem;
		padding-bottom: 2.4rem;
		display: flex;
		flex-wrap: wrap;
		background: url(${ellipse}) no-repeat 100% -120%;
	}

	.story-title {
		display: none;

		@media (min-width: ${breakpoints.MOBILE}px) {
			display: block;
			text-align: left;
			width: 50%;

			h2 {
				padding-right: 8rem;
				max-width: 600px;
			}
		}
	}

	.video-container {
		position: relative;
		display: flex;
		width: 50%;

		.play-button {
			display: none;

			@media (min-width: ${breakpoints.MOBILE}px) {
				display: inline-flex;
				justify-self: center;
				margin: auto;
				z-index: 2;
			}
		}

		img {
			display: none;

			@media (min-width: ${breakpoints.MOBILE}px) {
				display: block;
				position: absolute;
				left: 141px;
				bottom: -64px;
				width: 300px;
				z-index: 1;
			}
		}
	}
`
